export var ColorFormat;
(function (ColorFormat) {
  ColorFormat["hex"] = "hex";
  ColorFormat["rgb"] = "rgb";
  ColorFormat["hsb"] = "hsb";
})(ColorFormat || (ColorFormat = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/color-picker/interface.js
// module id = 3832
// module chunks = 0